import ProviderSlide from "../../components/providers-slide";
import PopularGames from "../../components/popular-games";
import React, {useEffect, useState} from "react";
import TopGames from "../../components/top-games";
import MiniGames from "../../components/mini-games";
import NewGames from "../../components/new-games";
import FreeSpinGames from "../../components/freespin-games";
import HighRtpGames from "../../components/high-rtp-games";
import JackpotGames from "../../components/jackpot-games";
import BuyBonusGames from "../../components/buy-bonus-games";
import InstantWinGames from "../../components/instant-win-games";
import LiveCasino from "../../components/live-casino";
import GeneralStats from "../../components/debit-table/casino-debit-stats";
import {useTranslation} from "react-i18next";
import associateServices from "../../services";
import SearchResults from "../casino-group/search-results";
import {useSelector} from "react-redux";
import MiniSlider from "../homepage/mini-slider";
import CasinoLobbyGroups from "./group";

const Casino = () => {
    const {agent} = useSelector(state => state.globalReducer)

    const {t} = useTranslation()

    return (
        <>
            <div className="section section--first">
                <MiniSlider page={'casino'} rowItem={2}/>
            </div>


            {
                !agent?.isMobile &&
                <div className="section container">
                    <SearchResults type={'casino'}/>
                </div>
            }

            <CasinoLobbyGroups/>

            {/*<TopGames/>*/}

            {/*<MiniGames/>*/}

            {/*<PopularGames/>*/}

            {/*<NewGames/>*/}

            {/*<FreeSpinGames/>*/}

            {/*<HighRtpGames/>*/}

            {/*<JackpotGames/>*/}

            {/*<BuyBonusGames/>*/}

            {/*<InstantWinGames/>*/}

            {/*<LiveCasino/>*/}

            <GeneralStats/>

            <ProviderSlide/>

        </>

    )

}

export default Casino
